import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Problem from "@/components/sections/Problem";
import InteractiveDemo from "@/components/sections/InteractiveDemo";
import IconBoard from "@/components/sections/IconBoard";
import Features from "@/components/sections/Features";
import FamilyLink from "@/components/sections/FamilyLink";
import SupervisorDemo from "@/components/sections/SupervisorDemo";
import Compliance from "@/components/sections/Compliance";
import ProPlus from "@/components/sections/ProPlus";
import Pricing from "@/components/sections/Pricing";
import FounderOffer from "@/components/sections/FounderOffer";
import Trust from "@/components/sections/Trust";
import DownloadSection from "@/components/sections/DownloadSection";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <InteractiveDemo />
        <IconBoard />
        <Features />
        <FamilyLink />
        <SupervisorDemo />
        <Compliance />
        <ProPlus />
        <Pricing />
        <FounderOffer />
        <Trust />
        <DownloadSection />
      </main>
      <Footer />
    </div>
  );
}
